export default "__VITE_ASSET__DKW63V_o__"